(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.scrollRafId = null;
    this._headerGeometryReady = false;
    /** Document Y at bottom of header in normal flow (offsetTop chain). Stable while sticky - avoids getBoundingClientRect+scrollY flicker. */
    this._scrollPastThreshold = 0;
    /** Cached 'scrolled-past-header' class state so applyScrollState can skip classList mutations when the state hasn't changed. */
    this._isPastHeader = false;
    this._lastIntentUpAt = 0;
    this._revealScrollAccum = 0;
    /** Pixels scrolled down while past the hide line (slow touch scroll rarely exceeds per-frame hide delta). */
    this._downScrollAccum = 0;
    this.onResizeBound = this.onResize.bind(this);
    this.scheduleScrollUpdate = this.scheduleScrollUpdate.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);
    this._mql767 = window.matchMedia('(max-width: 767.98px)');
  }

  /** Auto hide-on-scroll-down / show-on-scroll-up: on-scroll-up & reduce-logo-size. "always" stays visible. */
  get canAutoHide() {
    const t = this.getAttribute('data-sticky-type');
    return t === 'on-scroll-up' || t === 'reduce-logo-size';
  }

  connectedCallback() {
    this.header = this.closest('.section-header') || document.querySelector('.section-header');
    this.predictiveSearch = this.querySelector('predictive-search');
    this._headerGeometryReady = false;
    this.currentScrollTop = null;
    this.header.classList.add('shopify-section-header-sticky');
    this._mql767.addEventListener('change', this.onBreakpointChange);
    window.addEventListener('resize', this.onResizeBound, { passive: true });
    window.addEventListener('scroll', this.scheduleScrollUpdate, { passive: true });
    document.addEventListener('shopify:section:load', this.onResizeBound);
    // Initial observer delivery follows normal layout, avoiding startup reads
    // after custom-element upgrades have changed accordion/header styles.
    if (typeof ResizeObserver === 'function') {
      this._headerSizeObserver = new ResizeObserver(() => this.syncHeaderGeometry());
      this._headerSizeObserver.observe(this.header);
    } else {
      requestAnimationFrame(() => this.syncHeaderGeometry());
    }
  }
  onBreakpointChange() {
    this.syncHeaderGeometry();
  }
  onResize() {
    this.syncHeaderGeometry();
  }
  syncHeaderGeometry() {
    if (!this.header) return;
    const height = this.header.offsetHeight;
    let top = 0;
    let el = this.header;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    const initialScrollTop = !this._headerGeometryReady
      ? Math.round(window.pageYOffset || document.documentElement.scrollTop || 0)
      : null;
    this._scrollPastThreshold = top + height;
    if (!this._headerGeometryReady) {
      this.currentScrollTop = initialScrollTop;
      this._headerGeometryReady = true;
    }
    const value = `${height}px`;
    if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
      document.documentElement.style.setProperty('--header-height', value);
    }
  }
  refreshScrollPastThreshold() {
    if (!this.header) return;
    let top = 0;
    let el = this.header;
    while (el) {
      top += el.offsetTop;
      el = el.offsetParent;
    }
    this._scrollPastThreshold = top + this.header.offsetHeight;
  }
  setHeaderHeight() {
    if (!this.header) return;
    const value = `${this.header.offsetHeight}px`;
    if (document.documentElement.style.getPropertyValue('--header-height') !== value) {
      document.documentElement.style.setProperty('--header-height', value);
    }
  }
  disconnectedCallback() {
    this._headerSizeObserver?.disconnect();
    this._headerSizeObserver = null;
    this._cancelHideEndCleanup();
    this._mql767.removeEventListener('change', this.onBreakpointChange);
    window.removeEventListener('scroll', this.scheduleScrollUpdate);
    window.removeEventListener('resize', this.onResizeBound);
    document.removeEventListener('shopify:section:load', this.onResizeBound);
    if (this.scrollRafId != null) {
      cancelAnimationFrame(this.scrollRafId);
      this.scrollRafId = null;
    }
  }
  scheduleScrollUpdate() {
    if (this.scrollRafId != null) return;
    this.scrollRafId = requestAnimationFrame(() => {
      this.scrollRafId = null;
      this.applyScrollState();
    });
  }
  applyScrollState() {
    if (!this._headerGeometryReady) return;
    if (!this.header) return;

    const scrollTop = Math.round(window.pageYOffset || document.documentElement.scrollTop || 0);
    const scrollDelta = scrollTop - this.currentScrollTop;

    // Bail out if the browser schedules the RAF but scroll hasn't actually
    // moved a pixel since last tick - prevents 65ms+ forced-style recalc on
    // every idle scroll frame (header tree is big, classList churn is costly).
    if (scrollDelta === 0) return;

    if (this._scrollPastThreshold <= 0) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop <= this._scrollPastThreshold) {
      this._downScrollAccum = 0;
    }

    // Only toggle the class when the past/not-past state actually flips.
    // classList.add/remove on an already-matching element still triggers
    // style invalidation on every descendant in some browsers.
    const wantsPast = scrollTop > this._scrollPastThreshold;
    if (wantsPast !== this._isPastHeader) {
      this._isPastHeader = wantsPast;
      this.header.classList.toggle('scrolled-past-header', wantsPast);
    }

    if (!this.canAutoHide) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollDelta < -2) {
      this._lastIntentUpAt = performance.now();
    }

    const isHidden = this.header.classList.contains('shopify-section-header-hidden');
    const isMobile = this._mql767.matches;
    /* Desktop: extra slack past header bottom. Mobile: small buffer so hide doesn’t wait for “half the page”. */
    const hideBufferPx = isMobile ? 10 : 48;
    const downHideDelta = isMobile ? 2 : 3;
    /** Total downward scroll (may span many frames) to count as “scrolling down” on touch devices */
    const downHideAccumPx = isMobile ? 12 : 18;
    const upShowAccumPx = 15;
    const upShowQuick = 10;
    /* Block reveal for 520ms after hide() - matches the CSS transform
       transition so the hide animation always completes before reveal can
       fire again. Prevents any visual flash during the hide transition. */
    const revealCooldownMs = 520;
    const suppressHideAfterUpMs = 280;
    const searchOpen = !!(this.predictiveSearch && this.predictiveSearch.isOpen);

    if (isHidden) {
      /* Any non-upward delta fully resets the accumulator so momentum
         plateaus (delta = 0, 1, 2) can't creep it past the threshold. */
      if (scrollDelta < 0) {
        this._revealScrollAccum += -scrollDelta;
      } else {
        this._revealScrollAccum = 0;
        /* Any downward-or-zero delta also cancels a pending reveal. */
        this._revealPendingSince = 0;
      }
      const revealByAccum = this._revealScrollAccum >= upShowAccumPx;
      const revealByQuick = scrollDelta < -upShowQuick;
      const backInHeaderZone = scrollTop <= this._scrollPastThreshold;
      const justHidden = this._lastHideAt && (performance.now() - this._lastHideAt < revealCooldownMs);

      /* A decisive upward gesture is explicit user intent. Let CSS reverse the
         in-flight transform instead of discarding that gesture for the full
         hide duration (which left the header stuck until a second scroll).
         Keep the cooldown only for small momentum noise. */
      if (revealByQuick || (backInHeaderZone && scrollDelta <= 0)) {
        this._revealScrollAccum = 0;
        this._revealPendingSince = 0;
        this.reveal();
      } else if (justHidden) {
        this._revealPendingSince = 0;
        this._revealScrollAccum = 0;
      } else if (revealByAccum) {
        /* Debounce accumulated micro-scrolls so trackpad momentum does not
           flash the header, while a real quick upward gesture stays instant. */
        if (!this._revealPendingSince) {
          this._revealPendingSince = performance.now();
        } else if (performance.now() - this._revealPendingSince > 120) {
          this._revealScrollAccum = 0;
          this._revealPendingSince = 0;
          this.reveal();
        }
      } else {
        this._revealPendingSince = 0;
      }
    } else {
      /* Header is visible - clear any stale pending-reveal state. */
      this._revealPendingSince = 0;
      const vh = Math.round(
        (window.visualViewport && window.visualViewport.height) || window.innerHeight || 0
      );
      /* Mobile: pull hide line slightly toward viewport (still never above header bottom). */
      let staticHideY = this._scrollPastThreshold + hideBufferPx;
      if (isMobile && vh > 0) {
        const tighten = Math.min(56, Math.round(vh * 0.07));
        staticHideY = Math.max(this._scrollPastThreshold + 4, staticHideY - tighten);
      }
      /* Same line as first hide: no extra “scroll past reveal position” requirement */
      const scrolledFarEnough = scrollTop > staticHideY;
      if (!scrolledFarEnough) {
        this._downScrollAccum = 0;
      } else if (scrollDelta < -1) {
        this._downScrollAccum = 0;
      } else if (scrollDelta > 0) {
        this._downScrollAccum += scrollDelta;
      }
      const scrollingDown =
        scrollDelta > downHideDelta || this._downScrollAccum >= downHideAccumPx;
      const hideSuppressedAfterUp = performance.now() - this._lastIntentUpAt < suppressHideAfterUpMs;
      if (
        scrolledFarEnough &&
        scrollingDown &&
        !hideSuppressedAfterUp &&
        !searchOpen &&
        !this.preventHide
      ) {
        this._downScrollAccum = 0;
        this.hide();
      }
    }

    this.currentScrollTop = scrollTop;
  }
  hide() {
    if (!this.canAutoHide) return;
    if (this.preventHide) return;
    if (this.header.classList.contains('shopify-section-header-hidden')) return;
    this._cancelHideEndCleanup();
    this._revealScrollAccum = 0;
    this._downScrollAccum = 0;
    this._lastHideAt = performance.now();
    this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-hidden');
    /* Closing <details> mid-transition changes header height → translateY(-100%) jumps. Run after transform settles. */
    const header = this.header;
    let hideSettled = false;
    const finishHide = () => {
      if (hideSettled) return;
      hideSettled = true;
      if (this._hideMenuCloseTimer != null) {
        clearTimeout(this._hideMenuCloseTimer);
        this._hideMenuCloseTimer = null;
      }
      if (this._hideTransitionEndHandler) {
        header.removeEventListener('transitionend', this._hideTransitionEndHandler);
        this._hideTransitionEndHandler = null;
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    };
    const onHideTransitionEnd = (e) => {
      if (e.target !== header || e.propertyName !== 'transform') return;
      finishHide();
    };
    this._hideTransitionEndHandler = onHideTransitionEnd;
    header.addEventListener('transitionend', onHideTransitionEnd);
    this._hideMenuCloseTimer = setTimeout(finishHide, 600);
  }
  _cancelHideEndCleanup() {
    if (this._hideTransitionEndHandler && this.header) {
      this.header.removeEventListener('transitionend', this._hideTransitionEndHandler);
      this._hideTransitionEndHandler = null;
    }
    if (this._hideMenuCloseTimer != null) {
      clearTimeout(this._hideMenuCloseTimer);
      this._hideMenuCloseTimer = null;
    }
  }
  reveal() {
    if (!this.canAutoHide) return;
    if (!this.header.classList.contains('shopify-section-header-hidden')) return;
    this._cancelHideEndCleanup();
    this.header.classList.remove('shopify-section-header-hidden');
    this._downScrollAccum = 0;
    /* Do not refresh _scrollPastThreshold here - layout/height can change and move the bar upward,
       so the same scroll % no longer passes scrollTop > threshold + buffer on the next hide. */
    requestAnimationFrame(() => this.setHeaderHeight());
  }
  closeMenuDisclosure() {
    this.disclosures = this.header.querySelectorAll(
      'header-menu, .header__inline-menu details-disclosure'
    );
    this.disclosures.forEach((d) => d.close());
  }
  closeSearchModal() {
    const modal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal = modal;
    if (modal && typeof modal.close === 'function') {
      modal.close(false);
    }
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"]) return;
  try {
    
  if (!customElements.get('recently-viewed-products')) {
    class RecentlyViewedProducts extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-initialized')) return;
        this.setAttribute('data-initialized', '');
        this._abort = new AbortController();
        this.rail = this.querySelector('.recently-viewed__rail');
        this.status = this.querySelector('[data-recently-viewed-status]');
        this.clearButton = this.querySelector('[data-recently-viewed-clear]');
        this.previousButton = this.querySelector('.recently-viewed__arrow--previous');
        this.nextButton = this.querySelector('.recently-viewed__arrow--next');
        this.currentIndex = 0;
        this.invalidHandles = new Set();
        this.initialize();
      }

      disconnectedCallback() {
        this._abort?.abort();
        this.removeAttribute('data-initialized');
      }

      readHistory() {
        try {
          const value = JSON.parse(localStorage.getItem(RecentlyViewedProducts.storageKey) || '[]');
          if (!Array.isArray(value)) return [];
          const now = Date.now();
          const seen = new Set();
          return value.reduce((history, entry) => {
            const normalized = typeof entry === 'string' ? { handle: entry, viewedAt: now } : entry;
            if (!normalized || typeof normalized.handle !== 'string') return history;
            if (!/^[a-z0-9][a-z0-9-]*$/.test(normalized.handle)) return history;
            if (seen.has(normalized.handle)) return history;
            const viewedAt = Number(normalized.viewedAt) || now;
            if (now - viewedAt > RecentlyViewedProducts.maxAge) return history;
            seen.add(normalized.handle);
            history.push({ handle: normalized.handle, viewedAt });
            return history;
          }, []);
        } catch (error) {
          return [];
        }
      }

      writeHistory(history) {
        try {
          localStorage.setItem(
            RecentlyViewedProducts.storageKey,
            JSON.stringify(history.slice(0, RecentlyViewedProducts.maxStored))
          );
        } catch (error) {}
      }

      recordCurrent(history) {
        const currentHandle = this.dataset.currentProduct;
        if (!currentHandle || !/^[a-z0-9][a-z0-9-]*$/.test(currentHandle)) {
          this.writeHistory(history);
          return;
        }
        const nextHistory = history.filter((entry) => entry.handle !== currentHandle);
        nextHistory.unshift({ handle: currentHandle, viewedAt: Date.now() });
        this.writeHistory(nextHistory);
      }

      async initialize() {
        const history = this.readHistory();
        const currentHandle = this.dataset.currentProduct;
        const limit = Math.max(2, Math.min(8, Number(this.dataset.limit) || 6));
        const handles = history
          .filter((entry) => entry.handle !== currentHandle)
          .slice(0, limit)
          .map((entry) => entry.handle);

        this.recordCurrent(history);
        if (!handles.length) return;

        const connection = this._abort;
        const render = () => {
          if (!connection.signal.aborted && this.isConnected) this.renderHistory(handles);
        };
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(render, { timeout: 600 });
        } else {
          window.setTimeout(render, 120);
        }
      }

      async renderHistory(handles) {
        const connection = this._abort;
        if (!this.isConnected || connection.signal.aborted) return;
        try {
          if (typeof window.__loadStylesheet !== 'function') return;
          await window.__loadStylesheet(this.dataset.stylesheetUrl);
        } catch (_) {
          // Keep the optional rail hidden on CSS failure; retain its history.
          return;
        }
        if (!this.isConnected || connection.signal.aborted) return;
        this.hidden = false;
        this.renderSkeletons(handles.length);
        this.clearButton.addEventListener('click', () => this.clearHistory(), { signal: this._abort.signal });
        this.bindAnalytics();
        this.bindControls();

        await this.loadCards(handles, (card, index) => {
          const skeleton = this.rail.querySelector(`[data-recently-viewed-skeleton-index="${index}"]`);
          if (card) {
            card.style.setProperty('--recently-viewed-index', index);
            card.classList.add('is-entering');
            skeleton?.replaceWith(card);
          } else {
            skeleton?.remove();
          }

          this.items = Array.from(this.rail.querySelectorAll('[data-recently-viewed-card]'));
          this.updateCurrentIndex();
        });
        this.pruneInvalidHistory();
        this.rail.querySelectorAll('.recently-viewed__skeleton').forEach((skeleton) => skeleton.closest('.recently-viewed__item')?.remove());

        this.rail.setAttribute('aria-busy', 'false');
        if (!this.rail.children.length) {
          this.hidden = true;
          return;
        }

        this.status.textContent = this.dataset.loadedMessage;
        this.publishAnalytics('alasil:recently_viewed_impression', {
          product_handles: this.items.map((item) => item.dataset.productHandle).filter(Boolean),
          product_count: this.items.length
        });
        this.dispatchEvent(new CustomEvent('recently-viewed:rendered', { bubbles: true }));
      }

      renderSkeletons(count) {
        const fragment = document.createDocumentFragment();
        for (let index = 0; index < count; index += 1) {
          const item = document.createElement('li');
          item.className = 'recently-viewed__item';
          item.setAttribute('aria-hidden', 'true');
          item.dataset.recentlyViewedSkeletonIndex = index;
          const skeleton = document.createElement('div');
          skeleton.className = 'recently-viewed__skeleton';
          item.appendChild(skeleton);
          fragment.appendChild(item);
        }
        this.rail.replaceChildren(fragment);
      }

      async loadCards(handles, onSettled) {
        const cards = new Array(handles.length).fill(null);
        let nextIndex = 0;
        const worker = async () => {
          while (nextIndex < handles.length) {
            const index = nextIndex;
            nextIndex += 1;
            cards[index] = await this.fetchCard(handles[index]);
            onSettled?.(cards[index], index);
          }
        };
        const workers = Array.from({ length: Math.min(3, handles.length) }, worker);
        await Promise.all(workers);
        return cards;
      }

      async fetchCard(handle) {
        const rootUrl = (this.dataset.rootUrl || '/').replace(/\/$/, '');
        const url = `${rootUrl}/products/${encodeURIComponent(handle)}?section_id=recently-viewed-card`;
        try {
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) {
            if (response.status === 404 || response.status === 410) this.invalidHandles.add(handle);
            return null;
          }
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = documentFragment.querySelector('[data-recently-viewed-card]');
          if (!card || !card.querySelector('.pcard')) {
            // A preview proxy or temporary verification response can return
            // HTML with a 200 status but no section markup. Do not erase the
            // shopper's history unless Shopify explicitly returned 404/410.
            return null;
          }
          const requiredCollection = this.dataset.requiredCollection || '';
          if (requiredCollection) {
            const productCollections = (card.dataset.productCollections || '').split(',').filter(Boolean);
            if (!productCollections.includes(requiredCollection)) return null;
          }
          const removeButton = card.querySelector('[data-recently-viewed-remove]');
          const promotionBar = card.querySelector('.pcard__fomo--banner');
          if (removeButton && promotionBar) promotionBar.appendChild(removeButton);
          return document.importNode(card, true);
        } catch (error) {
          return null;
        }
      }

      bindControls() {
        this.items = Array.from(this.rail.querySelectorAll('[data-recently-viewed-card]'));
        window.AlAsilRailDrag?.bind(this.rail, this._abort.signal);
        this.rail.addEventListener('click', (event) => {
          const removeButton = event.target.closest('[data-recently-viewed-remove]');
          if (!removeButton) return;
          event.preventDefault();
          event.stopPropagation();
          this.removeItem(removeButton.closest('[data-recently-viewed-card]'));
        }, { signal: this._abort.signal });
        this.previousButton.addEventListener('click', () => this.goTo(this.currentIndex - 1), { signal: this._abort.signal });
        this.nextButton.addEventListener('click', () => this.goTo(this.currentIndex + 1), { signal: this._abort.signal });
        let frame = 0;
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => this.updateCurrentIndex());
        }, { passive: true, signal: this._abort.signal });
        window.addEventListener('resize', () => this.updateCurrentIndex(), { passive: true, signal: this._abort.signal });
        this.updateButtons();
      }

      removeItem(card) {
        if (!card || card.classList.contains('is-removing')) return;
        const handle = card.dataset.productHandle || '';
        if (handle) {
          this.writeHistory(this.readHistory().filter((entry) => entry.handle !== handle));
        }
        card.classList.add('is-removing');
        window.setTimeout(() => {
          card.remove();
          this.items = Array.from(this.rail.querySelectorAll('.recently-viewed__item'));
          this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.items.length - 1));
          this.status.textContent = this.dataset.removedMessage;
          if (!this.items.length) {
            this.hidden = true;
            return;
          }
          this.updateCurrentIndex();
        }, 180);
      }

      pruneInvalidHistory() {
        if (!this.invalidHandles.size) return;
        const history = this.readHistory().filter((entry) => !this.invalidHandles.has(entry.handle));
        this.writeHistory(history);
      }

      publishAnalytics(name, payload) {
        try {
          if (!window.Shopify?.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
          const publishResult = window.Shopify.analytics.publish(name, payload);
          if (publishResult && typeof publishResult.catch === 'function') publishResult.catch(() => {});
        } catch (error) {}
      }

      bindAnalytics() {
        this.rail.addEventListener('click', (event) => {
          const link = event.target.closest('a[href]');
          const card = link?.closest('[data-recently-viewed-card]');
          if (!card) return;
          const position = this.items.indexOf(card) + 1;
          this.publishAnalytics('alasil:recently_viewed_click', {
            product_handle: card.dataset.productHandle || '',
            position: Math.max(1, position),
            product_count: this.items.length
          });
        }, { signal: this._abort.signal });
      }

      clearHistory() {
        this.publishAnalytics('alasil:recently_viewed_clear', {
          product_count: this.rail.querySelectorAll('[data-recently-viewed-card]').length
        });
        try {
          localStorage.removeItem(RecentlyViewedProducts.storageKey);
        } catch (error) {}
        this.clearButton.disabled = true;
        this.status.textContent = this.dataset.clearedMessage;
        this.classList.add('is-clearing');
        window.setTimeout(() => {
          this.hidden = true;
          this.classList.remove('is-clearing');
          this.closest('main')?.focus({ preventScroll: true });
        }, 220);
      }

      goTo(index) {
        const targetIndex = Math.max(0, Math.min(this.items.length - 1, index));
        const target = this.items[targetIndex];
        if (!target) return;
        this.currentIndex = targetIndex;
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'start'
        });
        this.updateButtons();
      }

      updateCurrentIndex() {
        const railRect = this.rail.getBoundingClientRect();
        const isRtl = getComputedStyle(this.rail).direction === 'rtl';
        let closestDistance = Number.POSITIVE_INFINITY;
        let closestIndex = 0;
        this.items.forEach((item, index) => {
          const itemRect = item.getBoundingClientRect();
          const distance = Math.abs(isRtl ? railRect.right - itemRect.right : itemRect.left - railRect.left);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });
        this.currentIndex = closestIndex;
        this.updateButtons();
      }

      updateButtons() {
        const hasOverflow = this.rail.scrollWidth > this.rail.clientWidth + 2;
        this.previousButton.disabled = !hasOverflow || this.currentIndex === 0;
        this.nextButton.disabled = !hasOverflow || this.currentIndex >= this.items.length - 1;
      }
    }

    RecentlyViewedProducts.storageKey = 'alasil:recently-viewed:v1';
    RecentlyViewedProducts.maxStored = 12;
    RecentlyViewedProducts.maxAge = 30 * 24 * 60 * 60 * 1000;
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
